module.exports = __webpack_public_path__ + "media/images/site-section/headshot-58ef02f42868194f759a3c132b048e9d.svg";